import { Pages } from '.generated/Project.CW.model';
import { MedicalWebPage, WithContext } from 'schema-dts';
import { getBaseUrl } from 'lib/utils/get-base-url';
import { stripHtmlTags } from 'lib/utils/string-utils';
import { MinimalSchemaItem } from 'lib/schema-builders/minimal-schema-item';

const resolveReviewedByField = (
  baseUrl: string,
  item?: MinimalSchemaItem
): MedicalWebPage['reviewedBy'] => {
  const lowerPath = item?.url?.path;
  // Early return if no reviewer is defined. Just use CW Organization
  if (!lowerPath) {
    return { '@type': 'Organization', '@id': `${baseUrl}` };
  }

  if (lowerPath.includes('/providers/')) {
    return { '@type': 'Person', '@id': getLocalizedUrl(baseUrl, item) };
  }

  return {
    '@type': 'Organization',
    '@id': `${baseUrl}`,
    department: {
      '@type': 'Organization',
      '@id': getLocalizedUrl(baseUrl, item),
    },
  };
};

export const buildTeachingSheetPageJsonLd = (
  data: Pages.TeachingPages.TeachingSheets,
  pageUrl: string,
  relatedLinks?: MinimalSchemaItem[],
  reviewer?: MinimalSchemaItem
): WithContext<MedicalWebPage> => {
  const baseUrl = getBaseUrl();

  return {
    '@context': 'https://schema.org',
    '@type': 'MedicalWebPage',
    '@id': pageUrl,
    name: data.fields?.Title?.value,
    description: stripHtmlTags(data.fields?.Description?.value),
    url: pageUrl,
    medicalAudience: { '@type': 'MedicalAudienceType', name: 'Patient' },
    reviewedBy: resolveReviewedByField(baseUrl, reviewer),
    relatedLink: relatedLinks?.map((r) => getLocalizedUrl(baseUrl, r)),
  };
};

const getLocalizedUrl = (baseUrl: string, item: MinimalSchemaItem) => {
  const locale = item.language.name === 'es-ES' ? '/es-ES' : '';
  return `${baseUrl}${locale}${item.url.path?.toLowerCase()}`;
};
